import {
  attendItems,
  attendMonthItems,
  attendMyItems,
  attendIndexPage
} from '@/api/attend'

const attend = {
  state: {

  },
  mutations: {

  },
  actions: {
    AttendIndexPage ({ commit }) {
      return new Promise((resolve, reject) => {
        attendIndexPage().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AttendItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        attendItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AttendMonthItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        attendMonthItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AttendMyItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        attendMyItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default attend



// WEBPACK FOOTER //
// ./src/store/modules/attend.js